import { render, staticRenderFns } from "./spainWxLogin.vue?vue&type=template&id=22373770&scoped=true&"
import script from "./spainWxLogin.vue?vue&type=script&lang=js&"
export * from "./spainWxLogin.vue?vue&type=script&lang=js&"
import style0 from "./spainWxLogin.vue?vue&type=style&index=0&id=22373770&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22373770",
  null
  
)

export default component.exports